import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { assignPeerSupportLeadPost } from '@/services/api/requests/peer-support';

const usePeerSupportLeadAssign = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ organizationId, userId }: { organizationId: string; userId: string }) => {
      if (!organizationId) throw Error('No Organization ID');

      const response = await assignPeerSupportLeadPost(organizationId, userId);

      return response;
    },
    onSuccess: () => {
      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Peer Support Lead upgrade successful!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          status: 'error',
          title: 'Error',
          description: 'Error while upgrading Peer Support to Lead',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default usePeerSupportLeadAssign;
